import Card from '../Card';
import { EntryCardProps } from '../Blocks/BlockComponents/EntryCardBlock/useEntryCard';

export type InstagramPostCardProps = EntryCardProps<'instagramPost'>;

export const InstagramPostCard = ({ item, ...props }: InstagramPostCardProps) => {
  const { title, caption, entryImage, imageSingle } = item;
  const image = entryImage || imageSingle;

  return (
    <Card
      fullHeight
      elevation={false}
      {...props}
      item={{
        title,
        image,
        description: caption,
      }}>
      <Card.Image alt="" ShimProps={{ ratio: 'square' }} hover={false} />
    </Card>
  );
};
